// extracted by mini-css-extract-plugin
export default {"input-main":"InputSection_input-main__Y9QC6","widthChange":"InputSection_widthChange__qZU4A"};